import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Button from "./utilities/Button";

import ContentLoader from "react-content-loader";
import AddRdvType from "./utilities/AddRdvType";
import EditRdvType from "./utilities/EditRdvType";

const update = require("immutability-helper");

const TableLoader = () => (
  <ContentLoader
    height={200}
    width={400}
    speed={2}
    primaryColor={"#f3f3f3"}
    secondaryColor={"#ecebeb"}
  >
    <rect
      x="101"
      y="16.05"
      rx="5"
      ry="5"
      width="220"
      height="16.299999999999997"
    />
    <rect x="101" y="50" rx="5" ry="5" width="220" height="10" />
    <rect x="101" y="74" rx="5" ry="5" width="220" height="10" />
    <rect x="100" y="100" rx="5" ry="5" width="220" height="10" />
  </ContentLoader>
);

class RdvTypes extends React.Component {
  state = {
    handleCancel: null,
  };

  componentWillReceiveProps(newProps) {
    if (!newProps.allSlotTypesQuery.loading) {
      this.setState({ rdvTypes: newProps.allSlotTypesQuery.allSlotTypes });
    }
  }
  saveNewOrder = () => {
    this.state.rdvTypes.map(async ({ id }, index) => {
      await this.props.updateSlotTypeIndexMutation({
        variables: { id, index },
      });
    });
  };
  moveRow = (dragIndex: number, hoverIndex: number) => {
    const { rdvTypes } = this.state;

    const draggedRow = rdvTypes[dragIndex]; // Object.assign({}, rdvTypes[dragIndex]);

    this.setState(
      update(this.state, {
        rdvTypes: {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, draggedRow],
          ],
        },
      })
    );
  };

  renderRow = () => {
    if (this.props.allSlotTypesQuery.loading) {
      return (
        <div className="columns  is-centered">
          <div className="column is-4 has-text-centered">
            <TableLoader />
          </div>
        </div>
      );
    }
    if (this.state.rdvTypes === undefined) {
      return null;
    }
    return this.state.rdvTypes.map((slotType, i) => (
      <EditRdvType
        refetch={this.props.allSlotTypesQuery.refetch}
        key={slotType.id}
        moveRow={this.moveRow}
        saveNewOrder={this.saveNewOrder}
        id={slotType.id}
        index={i}
        slotType={slotType}
        doctorId={this.props.doctorId}
        toggleConfirm={this.toggleConfirm}
        setHandleCancel={this.setHandleCancel}
      />
    ));
  };
  toggleConfirm = () => {
    this.setState({ confirm: !this.state.confirm });
  };

  handleCancel = () => {
    this.state.handleCancel();
  };
  setHandleCancel = (handleCancel) => {
    this.setState({ handleCancel });
  };

  render() {
    if (this.props.allSlotTypesQuery.loading) {
      return (
        <div className="columns  is-centered">
          <div className="column is-4 has-text-centered">
            <TableLoader />
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            position: "relative",
          }}
        >
          {this.state.confirm ? (
            <div className="modal-slot-overlay">
              <div className="modal-slot-overlay-content">
                <h1 className="title">Êtes-vous sûr?</h1>
                <p>
                  <Button
                    style={{
                      width: "100px",
                    }}
                    text="Retour"
                    onClick={this.toggleConfirm}
                  />
                  <Button
                    color="red"
                    text="Oui!"
                    onClick={this.handleCancel}
                    style={{
                      width: "100px",
                    }}
                  />
                </p>
              </div>
            </div>
          ) : null}
          <table
            className="table is-bordered margin-auto"
            style={{
              width: "70%",
            }}
          >
            <thead>
              <tr>
                <th>
                  <abbr title="Index - Défini l'order d'affichage des types de rendez-vous. Glisser-déposer cette celulle pour modifier l'ordre.">
                    Index
                  </abbr>
                </th>
                <th>
                  <abbr title="Libellé - Nom du type de rendez-vous">
                    Libellé
                  </abbr>
                </th>
                <th
                  style={{
                    width: "65px",
                  }}
                >
                  <abbr title="Public - Ce type est disponible dans le calendrier public">
                    Public
                  </abbr>
                </th>
                <th
                  style={{
                    width: "50px",
                  }}
                >
                  <abbr title="Durée - Nombre de slots que prend le rdv ">
                    Durée
                  </abbr>
                </th>
                <th>
                  <abbr title="Info - Information supplémentaires à afficher lors de la prise de rendez-vous">
                    Infos
                  </abbr>
                </th>
                <th
                  style={{
                    width: "125px",
                  }}
                />
              </tr>
            </thead>
            <tbody>
              {this.renderRow()}
              <AddRdvType
                doctorId={this.props.doctorId}
                index={this.state.rdvTypes.length}
                refetch={this.props.allSlotTypesQuery.refetch}
              />
            </tbody>
          </table>
        </div>
      );
    }
  }
}

const ALL_SLOTTYPES_QUERY = gql`
  query AllSlotTypesQuery($doctorId: ID!) {
    allSlotTypes(
      filter: { AND: [{ doctor: { id: $doctorId } }, { role_not: HIDDEN }] }
      orderBy: index_ASC
    ) {
      id
      name
      duration
      role
      infos
      index
    }
  }
`;

const UPDATE_RDVTYPE_INDEX_MUTATION = gql`
  mutation UpdateSlotTypIndexMutation($id: ID!, $index: Int) {
    updateSlotType(id: $id, index: $index) {
      id
    }
  }
`;

export default compose(
  graphql(ALL_SLOTTYPES_QUERY, {
    name: "allSlotTypesQuery",
    options: ({ doctorId }) => ({
      variables: { doctorId },
      fetchPolicy: "network-only",
    }),
  }),
  graphql(UPDATE_RDVTYPE_INDEX_MUTATION, {
    name: "updateSlotTypeIndexMutation",
  })
)(RdvTypes);



// WEBPACK FOOTER //
// ./src/components/RdvTypes.js